/*
 * card-video.js
 * Autoplays product-card videos on collection / featured-collection grids.
 *
 * - Muted, looping, no controls, plays inline.
 * - Only videos scrolled into view are loaded and played, so a 24-card
 *   collection page does not start 24 downloads at once.
 * - Re-initialises after Dawn's facet filtering / pagination, which replaces
 *   the whole grid via fetch.
 */
(function () {
  var REDUCE_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;

        if (entry.isIntersecting) {
          if (video.preload === 'none') video.preload = 'auto';

          var played = video.play();
          if (played && typeof played.then === 'function') {
            played
              .then(function () {
                video.setAttribute('data-playing', '');
              })
              .catch(function () {
                /* Blocked (data saver, low power mode). Poster image stays visible. */
              });
          } else {
            video.setAttribute('data-playing', '');
          }
        } else {
          video.pause();
          video.removeAttribute('data-playing');
        }
      });
    },
    { rootMargin: '100px 0px', threshold: 0.35 }
  );

  function init(root) {
    var scope = root || document;

    scope.querySelectorAll('video.card__video:not([data-card-video-ready])').forEach(function (video) {
      video.setAttribute('data-card-video-ready', 'true');

      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.controls = false;

      video.setAttribute('muted', '');
      video.setAttribute('loop', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('disablepictureinpicture', '');
      video.removeAttribute('controls');

      // Decorative: keep it out of the tab order and off screen readers.
      video.setAttribute('tabindex', '-1');
      video.setAttribute('aria-hidden', 'true');

      // Guard against anything else in the theme pausing it mid-loop.
      video.addEventListener('pause', function () {
        if (video.hasAttribute('data-playing') && !video.ended) {
          var resume = video.play();
          if (resume && resume.catch) resume.catch(function () {});
        }
      });

      if (REDUCE_MOTION) return;
      observer.observe(video);
    });
  }

  var pending;
  function schedule() {
    clearTimeout(pending);
    pending = setTimeout(function () {
      init();
    }, 50);
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  }

  // Theme editor.
  document.addEventListener('shopify:section:load', schedule);

  // Facet filtering, sorting, infinite scroll, quick-add modals.
  new MutationObserver(schedule).observe(document.body, {
    childList: true,
    subtree: true
  });
})();
